import { przezmorzeApi } from "../../../api/api";

export interface CmsComponent {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly buttonLabel: string;
  readonly buttonLink: string;
}

export async function getComponent(name: string, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<CmsComponent>(`/cms/components/${name}`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function updateComponent(component: CmsComponent, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.put<CmsComponent>(`/cms/components/${component.id}`, component, {
    signal: abortSignal,
  });
  return response.data;
}
